import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/index-enterprise')
  },
  {
    path: '/admissionguideline',
    name: 'Guideline',
    component: () => import('../views/page-guideline')
  },
  {
    path: '/facilities',
    name: 'Facilities',
    component: () => import('../views/page-facilities')
  },
  {
    path: '/camps',
    name: 'Camps',
    component: () => import('../views/page-camps')
  },
  {
    path: '/admissions',
    name: 'Admissions',
    component: () => import('../views/page-admissions')
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: () => import('../views/page-agreement')
  },
  {
    path: '/party',
    name: 'Party',
    component: () => import('../views/page-party')
  },
  {
    path: '/faqs',
    name: 'Faqs',
    component: () => import('../views/page-faqs')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/page-contact')
  },
  {
    path: "/:catchAll(.*)",
    component: () => import('../views/page-error')
  },
  
]


const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
